import Box from 'components/layouts/Box';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Text from 'components/commons/Text';
import { Row } from 'saladsoft-primitive';

const SettingsMenus = () => {
  const location = useLocation();
  const { listingId } = useParams();
  const navigate = useNavigate();
  const routes = [
    {
      route: `/admin/guides/checkout-info`,
      name: '이용안내',
    },
    {
      route: `/admin/guides/rules`,
      name: '체크인정보',
    },
    {
      route: `/admin/guides/manual`,
      name: '예약정보',
    },
    {
      route: `/admin/guides/promotions`,
      name: '프로모션',
      children: '프로모션 설정',
    },
    {
      route: `/admin/guides/amenities-settings`,
      name: '편의시설',
      children: '편의시설 설정',
    },
    { route: `/admin/guides/option-settings`, name: '옵션상품 설정', children: '옵션상품 설정' },
    {
      route: `/admin/guides/places-settings`,
      name: '가볼만한 곳',
      children: '가볼만한 곳 설정',
    },
  ];

  return (
    <div>
      <Row justifyContent="flex-start" padding="20px 0">
        <>설정</>
      </Row>
      <Row gap={10} flexDirection="column" width="100%">
        {routes.map((route) => (
          <div key={route.route} style={{ width: '300px' }}>
            <Box
              title={route.name}
              selected={location.pathname === route.route}
              onClick={() => navigate(route.route)}
            >
              <Text type="H5" buttonRole="DESCRIPTION">
                {route.children}
              </Text>
            </Box>
          </div>
        ))}
      </Row>
    </div>
  );
};

export default SettingsMenus;
